import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { isNotUndefined, isPromise } from "@faire/web--source/common/typescriptUtils";
import { useEffect, useRef, useState } from "react";
var SHOW_LOADING_SPINNER_DELAY = 1000;
export var useShouldShowSpinner = function(initialDisabled, initialLoading, initialOnClick) {
    var _useState = _sliced_to_array(useState(false), 2), internalLoading = _useState[0], setInternalLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), loadingDelayExpired = _useState1[0], setLoadingDelayExpired = _useState1[1];
    var asyncLoadingTimeout = useRef(undefined);
    var isMounted = useRef(true);
    var isDisabled = initialDisabled || initialLoading || internalLoading;
    useEffect(function() {
        // Set isMounted to true when the component mounts and to false when it unmounts.
        isMounted.current = true;
        return function() {
            isMounted.current = false;
            if (isNotUndefined(asyncLoadingTimeout.current)) {
                var _getWindow;
                (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.clearTimeout(asyncLoadingTimeout.current);
            }
        };
    }, []);
    /**
     * If provided onClick returns a promise this will automatically set the button into a loading state.
     */ var handleClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var promise, _getWindow, _getWindow1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isDisabled) {
                            e.preventDefault();
                            return [
                                2
                            ];
                        }
                        promise = initialOnClick === null || initialOnClick === void 0 ? void 0 : initialOnClick(e);
                        if (!isPromise(promise)) return [
                            3,
                            4
                        ];
                        setInternalLoading(true);
                        asyncLoadingTimeout.current = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.setTimeout(function() {
                            if (isMounted.current) {
                                setLoadingDelayExpired(true);
                            }
                        }, SHOW_LOADING_SPINNER_DELAY);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.clearTimeout(asyncLoadingTimeout.current);
                        asyncLoadingTimeout.current = undefined;
                        if (isMounted.current) {
                            setInternalLoading(false);
                            setLoadingDelayExpired(false);
                        }
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // only show spinner if loading prop passed or we are loading due to onClick promise and loading delay has passed.
    var shouldShowSpinner = initialLoading || internalLoading && loadingDelayExpired;
    return {
        isDisabled: isDisabled,
        handleClick: handleClick,
        shouldShowSpinner: shouldShowSpinner
    };
};
